<!--
This form allows the user to merge 2 locations into one
-->
<template>
  <div >
    <div @click="closeForm" class="iconButton link">
      <span class="ion-close"></span>
    </div>
    <div class="modal-header drag-handle" ref="modalHeader">
      <h6>Merge {{mergeType}}</h6>
    </div>
      <div class="modal-content padded40">
        <template v-if="success === false">
        <div class="row">
          <div class="col s12">
            This tool will allow you to merge two duplicate {{mergeType}}s together. <strong>Please note that merging is irreversible.</strong>
            <template v-if="mergeType === 'project'">Both projects must have their statuses set as Active and you must be be an admin on both projects in order to merge.</template>
            </div>
          </div>
          <div class="row">
            <div class="col s12 m6">
                <label>Source {{mergeType}} <span class="info-icon ion-information-circled" v-tooltip="tooltips.source"></span></label>
                <div>
                    <template v-if="mergeSourceInfo.locationName">{{mergeSourceInfo.locationName}}</template><template v-else>{{mergeSourceInfo.fullNm}}</template>
                </div>
            </div>
            <div class="col s12 m6">
                <label>Target {{mergeType}} <span class="info-icon ion-information-circled" v-tooltip="tooltips.target"></span></label>
                <select v-if="mergeType === 'location'" v-model="target" @change="getTargetDetails">
                <template v-for="(item, index) in targetList">
                        <option :key="index" :value="item" v-if="item.id !== mergeSourceInfo.id">
                        {{item.locationName}}
                        </option>
                    </template>
                </select>
                <select v-else v-model="target" @change="getTargetDetails">
                <template v-for="(item, index) in targetList">
                        <option :key="index" :value="item" v-if="item.id !== mergeSourceInfo.id && item.organizationId === mergeSourceInfo.organizationId && item.status === 'Active'">
                        {{item.fullNm}}
                        </option>
                    </template>
                </select>
            </div>
        </div>
        <div class="row">
          <div v-if="mergeSourceInfo.subDetails" class="col s12 m6">
            <label>{{mergeSourceInfo.locationName}} Summary</label>
            <template v-if="mergeSourceInfo.subDetails.length > 0">
              <div v-for="(project,index) in mergeSourceInfo.subDetails" v-bind:key="`srcproject`+index">
                <div>{{project.projectName}} - {{project.sensor}}</div>
              </div>
            </template>
          <div v-else>No Projects</div>
          </div>
          <div class="col s12 m6">
            <div v-if="target && targetDetails">
              <label>{{target.locationName}} Summary</label>
              <template v-if="targetDetails.length > 0">
                <div v-for="(project, index) in targetDetails" v-bind:key="`trgtproject`+index">
                  <div >{{project.projectName}} - {{project.sensor}}</div>
                </div>
              </template>
              <div v-else>No Projects</div>
            </div>
          </div>
          </div>
          </template>
          <template v-else>
            <div>
              <template v-if="mergeSourceInfo.locationName">{{mergeSourceInfo.locationName}}</template><template v-else>{{mergeSourceInfo.fullNm}}</template> has been successfully merged into <template v-if="target.locationName">{{target.locationName}}</template><template v-else>{{target.fullNm}}</template>
              </div>
            </template>
        <div class="modal-footer">
        <div class="status" :class="{'error':error,'message':!error}">{{message}}</div>
          <button v-if="success=== false" class="btn btn-success modal-trigger modal-action modal-close" id="sendRequest" @click="merge">
            <template>Merge</template>
          </button>
          <button class="btn btn-border modal-action modal-close" id="cancelAdd" @click="closeForm">Close</button>
        </div>
      </div>
    <!--<div v-if="loading" class="center" style="padding:40px;">
        <pulse-loader :loading="true" color="#C94412" size="15px" :width="60" :height="30"></pulse-loader>
        <div>{{commonMsg.loading}}</div>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue'; // required for tooltip
import {eventBus} from '@/lib/eventbus';
import {API_URL, attachAuthorizaitonHeader} from '@/lib/common';
import { VTooltip } from 'v-tooltip';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue' // spinner for loading
import FormMixin from '@/components/common/FormMixin.js';
Vue.directive('tooltip', VTooltip)

export default {
  name: 'merge-location-form',
  props: ['mergeSourceInfo', 'organizationId', 'mergeType'],
  // components: {'pulse-loader': PulseLoader},
  mixins: [FormMixin],
  data () {
    return {
      mergeLocationsUrl: API_URL + 'merge-locations',
      getLocationsUrl: API_URL + 'get-location-summary',
      getTargetDetailsUrl: API_URL + 'get-location-details-view?organizationId=',
      getProjectsUrl: API_URL + 'get-project-summary?sensorId=',
      mergeProjectsUrl: API_URL + 'merge-project',
      target: null,
      message: null,
      error: false,
      targetList: [],
      targetDetails: null,
      success: false,
      tooltips: {
        source: `Information from this ${this.mergeType} will be merged into the target`,
        target: `The target ${this.mergeType} will receive data from the source location`
      },
      headers: {
        'Content-Type': 'application/json'
      }
    }
  },
  async created () {
    attachAuthorizaitonHeader();
    if (this.mergeType === 'location') {
      this.getLocationList();
    } else {
      this.getProjectList();
    }
  },
  methods: {
    merge () {
      this.error = false;
      this.message = '';
      let params = {};
      if (this.mergeType === 'project') {
        params = {targetProjectId: this.target.id, sourceProjectId: this.mergeSourceInfo.id};
      } else {
        params = {targetId: this.target.id, sourceId: this.mergeSourceInfo.id};
      }

      this.$http.post(this.mergeType === 'project' ? this.mergeProjectsUrl : this.mergeLocationsUrl, null, {params, headers: this.headers}).then(function (response) {
        if (response.body.error) {
          this.error = true;
          this.message = response.body.error;
        } else {
          this.success = true;
        }
      }, () => {
        // error callback
        this.error = true;
        this.message = 'An error occurred, unable to merge projects.';
      });
    },
    getLocationList () {
      this.$http.get(this.getLocationsUrl, {params: {organizationId: this.organizationId}}).then(function (response) {
        if (response.body.error) {
          this.error = true;
          this.message = 'There was a problem retrieving location data';
        } else {
          this.targetList = response.body.results;
          // sort objects by locationName
          this.targetList.sort((a, b) => {
            if (a.locationName > b.locationName) {
              return 1;
            }
            if (a.locationName < b.locationName) {
              return -1;
            }
            return 0;
          });
        }
      });
    },
    getProjectList () {
      // if from project page
      this.$http.get(this.getProjectsUrl + this.mergeSourceInfo.sensorId + '&filters%5B0%5D%5Bcolumn%5D=isAdmin&filters%5B0%5D%5Bvalue%5D=true').then((response) => {
        if (response.body.hasOwnProperty.call('error')) {
          this.error = true;
          this.message = 'There was a problem retrieving project data';
        } else {
          this.targetList = response.body.results;
          this.targetList.sort((a, b) => {
            if (a.fullNm > b.fullNm) {
              return 1;
            }
            if (a.fullNm < b.fullNm) {
              return -1;
            }
            return 0;
          });
          // need to set source org id as a number instead of a string
          this.mergeSourceInfo.organizationId = this.targetList.find((item) => {
            if (item.id === this.mergeSourceInfo.id) {
              return item;
            }
          }).organizationId;
        }
      }, () => {
        // error callback
        this.error = true;
        this.message = 'There was a problem retrieving project data';
      });
    },
    getTargetDetails () {
      if (this.mergeType === 'project') {
        return;
      }
      this.error = false;
      this.message = '';
      this.$http.get(this.getTargetDetailsUrl, {params: {organizationId: this.organizationId, locationId: this.target.id}}).then(function (response) {
        if (response.body.error) {
          this.error = true;
          this.message = 'There was a problem getting target location data.';
        } else {
          this.targetDetails = response.body;
        }
      });
    },
    closeForm () {
      this.message = '';
      this.error = false;
      eventBus.$emit('close-merge-form');
      this.$modal.hide('merge-form');
      this.success = false;
      eventBus.$emit('reload-table');
    }
  }
}
</script>
<style>
.message {
  color: rgb(255, 123, 0);
}

.status{
  height: 25px;
}

.no-bottom-margin{
  margin-bottom: 0;
}

strong{
  font-weight: 550;
}

</style>
